import { EnvironmentProviders, LOCALE_ID, Provider } from "@angular/core";
import { DateAdapter as MatDateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MAT_LUXON_DATE_ADAPTER_OPTIONS, provideLuxonDateAdapter } from "@angular/material-luxon-adapter";

export const DateProviders:(Provider|EnvironmentProviders)[] = [
    {provide: LOCALE_ID, useValue: 'en-GB' },
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: {firstDayOfWeek: 1}},
    provideLuxonDateAdapter()
]